export default {
    // 公共模块
    common: {
        simplifiedChinese: '简体中文',
        ChineseTraditional: '繁體中文',
        English: 'English',
        personalCenter: '個人中心',
        contactCustomerService: '聯系客服',
        logOut: '退出登錄',
        home: '首頁',
        deviceManagement: '設備管理',
        roleAssignment: '角色分配',
        powerDistribution: '權限分配',
        accountManagement: '賬號管理',
        pleaseEnterName: '請輸入',
        pleaseSelectName: '請選擇',
        date: '內容',
        sex: '性別',
        serial: '序號',
        operation: '操作',
        empty: '清空',
        query: '查詢',
        del: '刪除',
        operateSuccess: '操作成功',
        passwd: '密碼',
        remark: '備註',
        isDisabled: '是否禁用',
        disabled: '禁用',
        notDisabled: '未禁用',
        pleaseEnter: '請輸入',
        pleaseSelect: '請選擇',
        roleName: '角色名稱',
        jurisdictionIds: '權限id',
        addingRoles: '添加角色',
        editRole: '編輯角色',
        addRights: '增加權限',
        changePermission: '修改權限',
        PermissionName: '權限名稱',
        authorityCredentials: '權限值',
        nameAccount: '賬號名稱',
        roleId: '權限id',
        addAccount: '添加賬號',
        modifyAccount: '修改賬號',
        ClientManagement: '用戶管理',
        addUser: '增加用戶',
        passwordPrompt: '請輸入6位以上英文+數字的組合密碼',
        telephone: '電話號碼',
        languageSwitch: '語言切換',
        verificationCode: '驗證碼',
        logIn: '登錄',
        getCode: '獲取驗證碼',
        afterObtaining: 's後獲取',
        pleaseWait: '請稍候...',
        loginFailure: '登錄失敗',
        WelcomeTo: '歡迎登陸',
        DeviceUuid: '設備uuid',
        deviceInterface: '添加設備',
        changeDeviceInterface: '修改設備',
        bindingInterface: '綁定設備Wi-Fi',
        wifi: 'Wi-Fi',
        add: '添加',
        name: "姓名",
        email: "郵箱",
        createTime: "創建時間",
        lastTime: "修改時間",
        edit: "編輯",
        Cancel: "取消",
        Confirm: "確認",
        pleaseEnterSamePassword: "請輸入相同的密碼",
        weekday: "工作日",
        startTime: "開始時間",
        endTime: "結束時間",
        deviceList: '設備列表',
        workingSchedule: '工作排班',
        workforceManagement: "排班管理",
        credentialManagement: "證件管理",
        workerManagement: "員工管理",
        facePhoto: "人臉照片",
        photo: "照片",
        scheduling: "排班",
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Weekday: "周日",
        IdentificationCard: "認別證（藍卡）",
        MacauResidentIdentityCard: "澳門居民身份證",
        certificateType: "證件類型",
        certificateTimeStart: "證件有效期開始",
        certificateTimeEnd: "證件有效期結束",
        MasterCardNot: "是否主卡",
        yes: "是",
        no: "否",
        IDNumber: "證件號碼",
        OnlyOneImage: "只能上傳一張圖片",
        pictureSize: "上傳圖片大小不能超過{size}MB!",
        pictureFormat: "上傳圖片只能是 {type} 格式!",
        ChangePassword: "修改密碼",
        AttendanceManagement: "考勤管理",
        DeviceNoteInformation: "設備備註信息",
        DeviceSNCode: "設備sn碼",
        OnlineOrNot: "是否在線",
        RemoteDoorOpening: "遠程開門",
        RemoteRestartOfDevices: "遠程重啟設備",
        DeleteDeviceRecords: "刪除設備記錄",
        DeleteWhitelist: "刪除白名單",
        CompanyName: "粵港澳大灣區科技傳播",
        SyncToDevice: "同步到設備",
        DataStatistics: "數據統計",
        PersonnelManagementSystem: "人員管理系統",
        NotConfigured: "暫未配置",
        EmployeeInformationEditing: "員工信息編輯",
        EmployeeCredentialsEditor: "員工證件編輯",
        AddEmployeeCredentials: "添加員工證件",
        CertificateRemarks: "證件備註",
        user: "用戶",
        employee: "員工",
        type: "類型",
        triggeringTime: "觸發時間",
        ExportForm1: "導出打卡記錄",
        ExportForm2: "導出全部打卡時間",
        equipment: "設備",
        AssociatedWithTheScheduledWorkers: "關聯排班的工人",
        dateRange: "日期範圍",
        snCode: "SN碼",
        DeviceSn: "設備sn碼（請直接到設備上查看）",
        StartDate: "開始日期",
        EndDate: "結束日期",
        ClockIn: "上班卡",
        ClockOut: "下班卡",
        leave: "請假",
        takeVacation: "休假",
        annualLeave: "年假",
        evection: "出差",
        rests: "其他",
        man: "男",
        woman: "女",
        CrossDayOrNot: "是否跨日",
        IDPhoto: "證件照片",
        dateOnBoard: "入職日期",
        dateOfDeparture: "離職日期",
        emergencyContact: "緊急聯系人",
        EmergencyContactNumber: "緊急聯系人電話",
        EmployeeID: "員工編號",
        hourlyWage: "時薪",
        dailyWage: "日薪",
        monthlyPay: "月薪",
        SalaryCalculationMethod: "薪資計算方式",
        remuneration: "薪資",
        pleaseUpload: "請上傳{name}",
        requiredField: "必填字段",
        to: "至",
        AdditionalShift: "添加班次",
        classes: "班次",
        TimeRequiredForAttendance: "應出勤時長",
        intermission: "中間休息時間",
        SchedulingType: "排班類型",
        FixedSchedule: "固定排班",
        IntelligentSchedule: "智能排班",
        jobcard: "職安卡",
        macao: "澳門居民身份證",
        laborid: "外地勞工證",
        hkid: "香港居民身份證",
        chinaid: "內地居民身份證",
        chinapermit: "內地居民通行證",
        more: "更多",
        AddMaximum: "班次最多添加{numb}個",
        noData: '暫無數據',
        attentionPleaseTips: '請注意!以下證件即將過期,請提前進行處理',
        systematicNotification: '系統通知',
        officeHours: '上班時間',
        closingTime: '下班時間',
        ClockingTime: '打卡時間',
        ProcessingFailure: "處理失敗，如有疑問請聯系管理員",
        OffLine: "離線",
        OnLine: "在線",
        tips1: "請註意您員工編號：{num}有可能重復了，如確認無重復請聯系管理員",
        tips2: "請註意您證件編號：{num}有可能重復了，如確認無重復請聯系管理員",
        hourFormat: "(小時製)可小數",
        ExportForm3: "導出排班表",
        MenuPermission: "菜單權限",
        beLate: "遲到",
        leaveEarly: "早退",
        overtime: "加班",
        tips3: "此操作會刪除該證件，是否刪除？",
        hint: "提示",
        managerName: "賬戶名稱",
        tips4: "請註意該賬戶名稱已被使用，請修改賬戶名",
        superManager: "超級管理員",
        ordinaryManager: "普通管理員",
        tips5: "添加設備失敗:設備sn已存在",
        PunchType: "打卡類型",
        plan: "安排",
        ActualAttendanceTime: "實際出勤時長",
        yyyymmdd: "日期",
        ProductMicrocosmic: "產品微觀",
        SchedulingManagementSystem: "排班管理系統",
        IntelligentUnlocking: "智能開鎖",
        onlineShoppingMall: "線上商城",
        partner: "合作夥伴",
        AboutUs: "關於我們",
        allRightReserved: "版權所有",
        contactUs: "聯系我們",
        content1: "輕松實現企業級人員管理",
        content2: "快速進行人員排班、表格導出等繁瑣功能",
        content3: "智能樓宇；智能物業管理；監控系統；防盜系統；電子商貿；網站建立等",
        content4: "打造移動電子商務平臺 ，提供一鍵式部署，實現簡單可靠穩定的商務平臺。",
        content5: "我們來自不同地區，因夢想相聚，組建團隊，每個團隊成員如同人的五官，缺一不可。",
        content6: "以實力為盾，自信為矛。我們堅信成功靠朋友，成長靠對手，成就靠團體。",
        title3: "企業從事於",
        title4: "核心理念",
        title5: "團隊作風",
        title6: "企業精神",
        btn1: "體驗使用",
        BayAreaTechnology: "灣區科技",
        Macao: "澳門",
        MacaoContent1: "聚我智慧",
        MacaoContent2: "掌控精彩",
        MacaoContent3: "給您驚喜",
        MacaoContent4: "先科新世紀，引領創輝煌。",
        MacaoContent5: "共襄大灣區夢，共創美好未來。",
        gongSi1: "公司名稱",
        gongSi2: "澤兆生軟件開發中心",
        gongSi3: "經營範圍",
        gongSi4: "壹般項目：人工智能理論與算法軟件開發；人工智能基礎軟件開發；軟件開發；軟件銷售；互聯網銷售（除銷售需要許可的商品）；計算機軟硬件及輔助設備零售；銷售代理。（除依法須經批准的項目外，憑營業執照依法自主開展經營活動）",
        gongSi5: "肆季映集文化活動策劃工作室",
        gongSi6: "壹般項目：組織文化藝術交流活動；攝像及視頻制作服務；攝影擴印服務。（除依法須經批准的項目外，憑營業執照依法自主開展經營活動）",
        gongSi7: "裕豐通訊水電工程公司",
        gongSi8: "建設工程施工;建設工程設計;道路貨物運輸（不含危險貨物）;通訊設備銷售;建築材料銷售;軟件開發;裝卸搬運;勞務服務（不含勞務派遣）。",
        IntelligentUnlocking: "智能開鎖系統",
        ScienceAndInnovationLife: "科創生活",
        CommittedTo: "致力灣區科技未來",
        theNumberOfUsers: "使用人數",
        serviceTeam: "服務團隊",
        ao: "澳",
    },
}
